import { render, staticRenderFns } from "./IntegrationFormSlack.vue?vue&type=template&id=e60b667c&scoped=true"
import script from "./IntegrationFormSlack.vue?vue&type=script&lang=js"
export * from "./IntegrationFormSlack.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFormSlack.vue?vue&type=style&index=0&id=e60b667c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60b667c",
  null
  
)

export default component.exports